import { TimestampableInterface } from './timestampable.interface';

export class Timestampable implements TimestampableInterface {
  creeLe: Date|null;
  majLe: Date|null;

  setCreeLe(date: string): void {
    this.creeLe = new Date(date);
  }

  setMajLe(date: string): void {
    this.majLe = new Date(date);
  }
}



// WEBPACK FOOTER //
// ./src/shared/models/ressources/timestampable.model.ts